(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9f35"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9f35"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("32oyj", function(module, exports) {

$parcel$export(module.exports, "initializeSentry", function () { return $23649a9bcd814e3d$export$1f7656c617418e15; });
$parcel$export(module.exports, "trackSentryEvent", function () { return $23649a9bcd814e3d$export$77df6c769305dc1e; });
const $23649a9bcd814e3d$var$SENTRY_DISABLED = false; // Set to true to disable all Sentry analytics
const $23649a9bcd814e3d$var$MY_ORG_ID = "5c9ac16cd9bcce32ded1aea3";
const $23649a9bcd814e3d$var$ALLOW_MY_ORG_ANALYTICS = false; // Set to true when testing analytics for your org
const $23649a9bcd814e3d$export$1f7656c617418e15 = ()=>{
    if ($23649a9bcd814e3d$var$SENTRY_DISABLED) return;
    if (typeof window.Sentry !== "undefined") {
        // Check if Sentry is already initialized to prevent multiple initializations
        if (window.Sentry._isInitialized) return true; // Already initialized
        window.Sentry.init({
            dsn: "https://fbf680d0b1e36c0bb2e3e004551208c4@o4507645100556288.ingest.us.sentry.io/4508150777315328",
            environment: "live",
            beforeSend (event) {
                if (window.location.hostname === "localhost") return null; // Don't send events from localhost
                return event;
            },
            // Optional: Configure sampling for analytics events
            tracesSampleRate: 1.0,
            // Optional: Configure sampling for errors
            sampleRate: 1.0
        });
        // Mark as initialized to prevent multiple initializations
        window.Sentry._isInitialized = true;
        return true;
    }
    return false;
};
const $23649a9bcd814e3d$export$77df6c769305dc1e = (eventName, properties = {})=>{
    if ($23649a9bcd814e3d$var$SENTRY_DISABLED) return;
    // Block analytics from your org unless allowed
    if (properties.organization_id === $23649a9bcd814e3d$var$MY_ORG_ID && !$23649a9bcd814e3d$var$ALLOW_MY_ORG_ANALYTICS) return;
    // Determine environment name, default to "unknown" if not set
    const envName = "live";
    const envSuffix = envName !== "live" ? `_${envName}` : "";
    let eventNameWithEnv = `${eventName}${envSuffix}`;
    // Add org ID suffix if its mine
    if (properties.organization_id === $23649a9bcd814e3d$var$MY_ORG_ID) eventNameWithEnv += `_${properties.organization_id}`;
    if (typeof window.Sentry !== "undefined") try {
        window.Sentry.addBreadcrumb({
            category: "analytics",
            message: eventNameWithEnv,
            data: properties,
            level: "info"
        });
        window.Sentry.captureMessage(`Analytics: ${eventNameWithEnv}`, {
            level: "info",
            tags: {
                event_type: "analytics",
                event_name: eventNameWithEnv
            },
            extra: properties
        });
    } catch (error) {
        console.error("Error tracking Sentry event:", error);
    }
    else if (window.location.hostname === "localhost") console.log("Sentry Event (dev):", eventNameWithEnv, properties);
};

});


var $lBpE3 = parcelRequire("lBpE3");

var $6cds3 = parcelRequire("6cds3");

var $8EDuI = parcelRequire("8EDuI");


var $lBpE3 = parcelRequire("lBpE3");
parcelRequire("6cds3");
function $a198c5b7f78064c1$var$App() {
    return /*#__PURE__*/ (0, $lBpE3.jsx)("div", {});
}
var $a198c5b7f78064c1$export$2e2bcd8739ae039 = $a198c5b7f78064c1$var$App;



var $k8iTi = parcelRequire("k8iTi");

var $32oyj = parcelRequire("32oyj");
// Initialize Sentry for global error logging and analytics
(0, $32oyj.initializeSentry)();
const $f25e85c08ff84b11$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($8EDuI))).createRoot(document.getElementById("root"));
$f25e85c08ff84b11$var$root.render(/*#__PURE__*/ (0, $lBpE3.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6cds3))).StrictMode, {
    children: /*#__PURE__*/ (0, $lBpE3.jsx)((0, $a198c5b7f78064c1$export$2e2bcd8739ae039), {})
}));
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
(0, $k8iTi.default)();

})();
//# sourceMappingURL=index.827fad03.js.map
